<template>
  <div class="main-frame">
    <div class="info-frame">
      <div class="back_header">
        <van-nav-bar title="SMOK" class="top_bar" fixed @click-left="backHome()">
          <template #title>
            <img class="logo-img" src="../assets/image/smoklogo.png" />
          </template>
          <template #left>
            <van-icon name="arrow-left" size="20" color="#000" />
          </template>
          <template #right>
            <div class="options">
              <van-dropdown-menu>
                <van-dropdown-item title="..." ref="item">
                  <van-cell
                    @click="onConfirm"
                    v-clipboard:copy="ACodeStr"
                    v-clipboard:success="onCopy"
                  >
                    <div class="options_title">复制箱唛码</div>
                    <van-icon
                      name="qr"
                      size="20"
                      color="#000"
                      v-clipboard:copy="ACodeStr"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    />
                  </van-cell>
                  <van-cell @click="changeLanguage()">
                    <div class="options_title">{{ $t("message.switch_language") }}</div>
                    <van-icon name="exchange" size="20" color="#000" />
                  </van-cell>
                </van-dropdown-item>
              </van-dropdown-menu>
            </div>
          </template>
        </van-nav-bar>
      </div>

      <!-- 占位高度 -->
      <van-divider class="top-divider" :style="{ borderColor: '#FFF' }" />
      <!-- 信息表格 -->

      <div v-if="shipping_mark_list && shipping_mark_list.length > 0">
        <p class="sn-num">Shipping Mark： {{ carton_code }}</p>

        <div
          class="mark_box"
          v-for="(item, i) in shipping_mark_list"
          :key="'shipping_mark' + i"
        >
          <van-grid :column-num="2">
            <van-grid-item text="Product Name:" />
            <van-grid-item :text="item.product_name" />
          </van-grid>
          <van-grid :column-num="2">
            <van-grid-item text="Carton Number:" />
            <van-grid-item :text="item.carton_code" />
          </van-grid>
          <van-grid :column-num="2">
            <van-grid-item text="Purchase Order:" />
            <van-grid-item :text="item.purchase_order" />
          </van-grid>
          <van-grid :column-num="2">
            <van-grid-item text="Product Description:" />
            <van-grid-item :text="item.descriptions" />
          </van-grid>
          <van-grid :column-num="2">
            <van-grid-item text="Quantity:" />
            <van-grid-item :text="item.quantity.toString()" />
          </van-grid>
        </div>
      </div>

      <div class="mark_no" v-else>
        {{ shipping_mark_no }}
      </div>
    </div>
    <div class="bottom-view">
      <!-- 装饰线条 -->
      <img class="img-margin" src="../assets/image/footer.png" />
      <!-- 版权说明 -->
      <foot></foot>
    </div>
  </div>
</template>

<script>
import foot from "@/components/Foot.vue";
import backHeader from "@/components/BackHeader.vue";
import Fingerprint2 from "fingerprintjs2";

export default {
  components: {
    foot,
    backHeader,
  },
  name: "A_activate",
  data() {
    return {
      ACodeStr: "",
      shipping_mark_list: [],
      carton_code: "",
      shipping_mark_no: "",
      id: "",
    };
  },
  created() {
    if (this.$route.params != undefined) {
      this.carton_code = this.$route.params.code;
      this.getShippingMarkModel(this.carton_code);
      this.ACodeStr = this.carton_code;
    }
    // else {
    //   // 返回主页
    //   this.$notify(this.$t("message.home_model_not_scanner_code_a"));
    //   this.$router.push({ name: "bind-home" });
    // }
  },
  methods: {
    backHome() {
      this.$router.push({ name: "bind-home" });
    },
    // handleClick() {
    //   this.$router.push({ name: "inform", params: { data: this.text } });
    // },
    onCopy(e) {
      //   console.log(e.text);
      this.$notify({ type: "success", message: "箱唛码复制成功" });
    },
    onConfirm() {
      this.$refs.item.toggle();
    },
    onError(e) {
      console.log(e);
      this.$notify(this.$t("message.copy_a_fail"));
    },
    getId: function () {
      // 获取唯一id
      let _me = this;
      let options = {};
      Fingerprint2.get(options, function (components) {
        let values = components.map(function (component) {
          return component.value;
        });
        let murmur = Fingerprint2.x64hash128(values.join(""), 83777975);
        _me.id = murmur;
      });
    },
    getShippingMarkModel(id) {
      let _me = this;

      let params = {
        access_key: ACCESS_KEY,
        // device: _me.id,
        carton_code: id,
        // type: TYPE,
      };
      this.common
        .httpPost("shipping/mark/info", params)
        .then((res) => {
          if (res.data.shipping_mark && res.data.shipping_mark.length > 0) {
            this.shipping_mark_list = res.data.shipping_mark;
          } else {
            this.shipping_mark_list = [];
            this.shipping_mark_no = res.data.message;
          }
        })
        .catch((err) => {
          _me.$notify("Web Error:", err);
          //   // console.log(err);
          //   _me.$router.push({ name: "bind-home" });
        });
    },
    changeLanguage() {
      this.$refs.item.toggle();
      this.common.language = !this.common.language;
      if (this.common.language) {
        this.$i18n.locale = "cn";
      } else {
        this.$i18n.locale = "en";
      }
    },
  },
};
</script>

<style scoped>
.main-frame {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: white;
  text-align: center;
}

.info-frame {
  flex: 1;
}

.mark_box {
  border: 1px solid #ebedf0;
  margin: 30px 10px;
}

.mark_no {
  font-size: 30px;
  margin: 200px 20px;
  line-height: 1.2;
}

.top-divider {
  background-color: white;
  margin: 0;
  height: 55px;
}

.sn-num {
  margin: 30px 30px 0;
  font-size: 20px;
  word-break: break-all;
}

.img-margin {
  width: 100%;
  height: 22px;
}

.bottom-view {
  min-height: 50px;
  margin-top: 20px;
  background-color: white;
}

.top_bar {
  height: 54px;
}

.logo-img {
  margin-top: 4px;
  height: 24px;
}

.back_header >>> .van-nav-bar__right {
  padding: 0;
  margin-right: 10px;
}

.back_header >>> .van-dropdown-menu__bar {
  box-shadow: 0 0 0;
}

.back_header >>> .van-dropdown-menu__title::after {
  border: 0;
}

.back_header >>> .van-icon {
  flex: 1;
  vertical-align: middle;
}

.back_header {
  width: 54px;
}

.back_header >>> .van-dropdown-menu__title--active {
  color: #323233;
}

.back_header >>> .van-cell__value {
  display: flex;
}

.options_title {
  font-size: 17px;
  margin-right: 8px;
}
</style>
